<template>
    <div :class="{ 'select-opt': true, 'select-active': showOptions, 'select-disabled': disabled }" @click="selectClick">
        <div class="current-text" :style="labelStyle">
            {{ currentLabel }}
        </div>
        <div @click.stop="searchHandle" ref="optionSearch">
            <slot v-if="showOptions"></slot>
        </div>
        <PopupMenu
            class="select-div select-input-popup scroll-tracker"
            :menus="options"
            :position="popupPosition"
            :isShow="showOptions"
            :current="initValue"
            @menuChange="menuChange"
            @menuHide="hideOption"
            :style="positionStyle"
            v-if="!noPopup"
        />
    </div>
</template>

<script>
import PopupMenu from "@/views/zhiji/bComponents/popupMenu/PopupMenu";

export default {
    name: "Select",
    // isFixed 选择面板是否根据窗口定位，可选(不传则默认根据父元素定位)
    props: ["options", "initValue", "direct", "topOrBottom", "disabled", "config", "labelStyle"],
    components: {
        PopupMenu
    },
    data() {
        return {
            currentLabel: this.initCurrent(),
            isShowOptions: false,
            positionStyle: ""
        };
    },
    computed: {
        popupPosition() {
            return {
                direct: this.direct || "bottom",
                topOrBottom: this.topOrBottom || 45
            };
        },
        showOptions() {
            return this.isShowOptions && this.options.length;
        },
        noPopup() {
            return this.config && this.config.noPopup;
        }
    },
    watch: {
        initValue() {
            this.currentLabel = this.initCurrent();
        },
        options() {
            if (this.$refs.optionSearch && this.$refs.optionSearch.children.length > 0) {
                return true;
            }
            this.currentLabel = this.initCurrent();
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        menuChange(data) {
            this.currentLabel = data.label;

            this.$emit("menuClick", {
                value: data.value,
                label: data.label
            });

            this.hideOption();
        },
        selectClick(event) {
            if (this.disabled) {
                return;
            }

            this.$nextTick(() => {
                this.isShowOptions = !this.isShowOptions;
            });

            this.$nextTick(() => {
                this.$emit("selectClick", {
                    isShowOptions: this.isShowOptions
                });
            });

            // 根据fixed定位
            this.config && this.config.isFixed && (this.positionStyle = this.getPosition(event.target));
        },
        initCurrent() {
            let currentLabel = "";
            this.options.some(option => {
                if (option.value == this.initValue) {
                    currentLabel = option.label;
                    return true;
                }
            });
            return currentLabel || (this.config ? this.config.initLabel : "");
        },
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isShowOptions = false;
            }
        },
        hideOption() {
            setTimeout(() => {
                this.isShowOptions = false;
            }, 100);
        },
        getPosition(target) {
            let position = {};
            target.className == "current-text"
                ? (position = target.offsetParent.getBoundingClientRect())
                : (position = target.getBoundingClientRect());

            return {
                position: "fixed",
                left: position.left + "px",
                top: position.top + position.height + 12 + "px",
                width: position.width + "px"
            };
        },
        searchHandle() {
            this.isShowOptions = true;
        }
    }
};
</script>

<style scoped lang="less">
.select-div {
    position: absolute;
    width: 100%;
    left: 0;

    background: #fff;
    display: none;
    border-radius: 4px;
    z-index: 2;
    max-height: 288px;
    overflow-y: auto;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

    li {
        padding: 6px 12px;
        cursor: pointer;
        &:hover,
        &.on {
            background: #e4f1f9;
            color: #2ec2ff;
        }
        &:hover {
            background: rgba(217, 235, 246, 0.7);
        }
        &.on {
            background: rgba(217, 235, 246, 1);
        }
    }
}
input {
    color: #41475e;
    outline: none;
    border: none;
    box-sizing: border-box;
    &::placeholder {
        color: #9b9ba3;
    }
    &:focus {
        &::placeholder {
            color: #c9c9c9;
        }
    }
}
.select-opt {
    position: relative;
    margin-right: 8px;
    width: 120px;
    font-size: 12px;
    box-sizing: border-box;
    padding: 4px 8px 5px;
    border: solid 1px #d8e4f0;
    border-radius: 4px;
    display: inline-block;
    background: #fff;
    cursor: pointer;
    &:after {
        background-image: url("@{zhijiStaticImagePath}class-spr.png");
        position: absolute;
        top: 11px;
        right: 10px;
        content: "";
        width: 6px;
        height: 10px;
        background-position: -127px -20px;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
    }
    select {
        display: none;
    }
}
.select-active {
    border-color: #2088f3;
    .select-div {
        display: block;
    }
    &:after {
        transform: rotate(270deg);
        transition: transform 0.2s ease-in-out;
    }
}
.select-disabled {
    background: #f2f2f2;
    color: #9b9ba3;
    cursor: not-allowed;
    border-color: #d8e4f0;
    &:after {
        opacity: 0.4;
    }
}
.select-opt {
    position: relative;
}
.current-text {
    height: 21px;
    line-height: 21px;
    min-width: 88px;
    max-width: calc(100% - 21px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
